<nav class="sidebar-nav">
  <ul class="nav">
    <ng-template ngFor let-navitem [ngForOf]="navigation">
      <ng-template [ngIf]="displayTitle(navitem,(auth.user | async))">
        <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
      </ng-template>
      <div *ngIf="displayNavItem(navitem,(auth.user | async))">
        <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
      </div>
    </ng-template>
  </ul>
</nav>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-sidebar-nav/app-sidebar-nav.component.html